import React from 'react'
import styles from './UserAvatar.scss'

interface UserAvatarProps {
  imageUrl?: string
  alt?: string
}

export default function UserAvatar({ imageUrl, alt }: UserAvatarProps) {
  return imageUrl ? (
    <img src={imageUrl} key={imageUrl} alt={alt} className={styles.image} />
  ) : (
    <img src={require('./assets/avatar.png')} alt={alt} className={styles.image} />
  )
}

